import { logos, logosBlack, logosWhite } from "./data";

/**
 * FEATURED_IN is a multivariant flag picking the logo set the marquee renders.
 * Anything the flag can carry outside these keys — missing, disabled, or an
 * unrecognised variant — resolves to `control`, which keeps the original logos.
 */
export const LOGOS_BY_VARIANT = {
    control: logos,
    black: logosBlack,
    white: logosWhite,
} as const;

export type FeaturedInVariant = keyof typeof LOGOS_BY_VARIANT;

export const FEATURED_IN_CONTROL: FeaturedInVariant = "control";

export const isFeaturedInVariant = (value: unknown): value is FeaturedInVariant =>
    typeof value === "string" && Object.hasOwn(LOGOS_BY_VARIANT, value);

export const getFeaturedInVariant = (flagValue: unknown): FeaturedInVariant =>
    isFeaturedInVariant(flagValue) ? flagValue : FEATURED_IN_CONTROL;
